export default "__VITE_ASSET__BTHJ$vsJ__"